import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class Parallax {
  constructor() {
    this._elements = document.querySelectorAll("[animation-parallax]");
    this.init();
  }

  init() {
    if (this._elements.length === 0) return;

    this._elements.forEach((el) => {
      const img = el.querySelector("img");
      if (!img) return;

      const speed = parseFloat(el.getAttribute("data-parallax-speed")) || 1;

      img.style.height = img.parentElement.offsetHeight + 200 + "px";
      let imgHeight = 100;

      const parallaxAmount = Math.round(-imgHeight * speed);

      // Initialise la position de l'objet
      img.style.objectPosition = `center ${parallaxAmount * 2}px`;
      img.style.willChange = "object-position";

      // Crée l'animation parallax
      gsap.to(img, {
        objectPosition: `center ${parallaxAmount * 0.8}px`,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
    });
  }
}
